/**
 * SubscriptionPlan entity class
 */

/**
 * SubscriptionPlanFactory
 * returns SubscriptionPlan entity class
 *
 * @class SubscriptionPlanFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SubscriptionPlan} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SubscriptionPlanFactory
 */
/* @ngInject */
export default function SubscriptionPlanFactory ($http, Entity, FileUploadMixin) {
  /* === SubscriptionPlan class === */

  /**
   * SubscriptionPlan model
   *
   * @class SubscriptionPlan
   * @classdesc SubscriptionPlan model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.SubscriptionPlan} SubscriptionPlan entity
   */
  function SubscriptionPlan () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SubscriptionPlan.prototype = Object.create(Entity.prototype)
  SubscriptionPlan.prototype.constructor = SubscriptionPlan

  /* === SubscriptionPlan instance methods & fields === */

  Object.assign(SubscriptionPlan.prototype, {

    /**
     * instance fields
     *
     * @memberof models.SubscriptionPlan#
     * @type {Object}
     */
    _fields: {
      id: Number,
      additionalInfo: String,
      coverImageUrl: String,
      description: String,
      label: String,
      labelEnabled: false,
      name: String,
      networkId: Number,
      sortOrder: Number,
      subscriptionPlanSettingsId: Number,
      subscriptionSettings: [{
        active: Boolean,
        amounts: ['Amount'],
        coverImageUrl: String,
        dueDate: String,
        currency: 'Currency',
        description: String,
        heading: String,
        length: Number,
        lengthType: String,
        name: String,
        promoLabel: String,
        periodUnlimited: Boolean,
        subscriptionId: Number,
        sortOrder: Number
      }],
      $promoLabelEnabled: Boolean
    },

    /**
     * url template
     *
     * @memberof models.SubscriptionPlan#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/shopping-cart/settings/plan/{{::subscriptionPlanSettingsId}}',

    /**
     * public url template
     *
     * @memberof models.acl#
     * @type {String}
     */
    _publicUrlTemplate: 'shoppingCart/{{::id}}'
  }, FileUploadMixin)

  /* === SubscriptionPlan static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(SubscriptionPlan, Entity)
  SubscriptionPlan._name = 'SubscriptionPlan'
  SubscriptionPlan.init()

  // permissions
  // SubscriptionPlan.access = {}

  // extra
  // SubscriptionPlan.extra = {}

  return SubscriptionPlan
}
